import { render, staticRenderFns } from "./HeaderSearch.vue?vue&type=template&id=5acaf60c&"
import script from "./HeaderSearch.vue?vue&type=script&lang=ts&"
export * from "./HeaderSearch.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports